module.exports = __webpack_public_path__ + "media/L.8cd257b7.mp3";